/** GENERATED by scripts/i18n-build.cjs from scripts/i18n/templates.json — edit that. */
export const TEMPLATES: string[] = [
  "{name} souhaite réserver {title}.",
  "L’hôte n’a pas répondu à temps pour « {title} ». Les dates sont de nouveau libres : vous pouvez réessayer ou chercher ailleurs.",
  "Le délai de paiement pour « {title} » est passé. Les dates ont été libérées.",
  "Vous n’avez pas répondu à la demande {reference} à temps ; elle a expiré.",
  "La réservation {reference} n’a pas été payée à temps ; les dates sont libérées.",
  "Le paiement des frais pour {reference} n’a pas abouti. Rien n’a été débité ; vous pouvez réessayer avant l’expiration de la demande.",
  "{name} a envoyé une pièce d’identité.",
  "« {title} » — {neighborhood}, {city}",
  "Nouveau logement à {city}"
];
